export default "__VITE_ASSET__BCSPI8hx__"